import { t } from "i18next";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CycleTypeService } from "../../services/CyclesService";
import { ReflectionTemplateService } from "../../services/ReflectionTemplateService";
import { SubjectService } from "../../services/SubjectService";
import { ERROR, useNotification } from "../CustomHooks/NotificationProvider";
import ManageReflectionTemplate from "./ManageReflectionTemplate";
import ViewReflectionTemplates from "./ViewReflectionTemplates";

const ReflectionTemplates = () => {
  const showNotification = useNotification();
  const location = useLocation();
  const [templates, setTemplates] = useState(null);
  const [cycleTypes, setCycleTypes] = useState([]);
  const [mode, setMode] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [allDepartments, setAllDepartments] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const [reflectionTemplates, cycleTypes, departments] =
          await Promise.all([
            ReflectionTemplateService.getTemplates(),
            CycleTypeService.getCycleTypes(),
            SubjectService.getSubjects({
              withExternalContext: false,
              allSubjects: true,
            }),
          ]);

        setTemplates(reflectionTemplates);
        setCycleTypes([
          ...cycleTypes.map((type) => ({ id: type.id, label: type.name })),
        ]);
        setAllDepartments(departments.map((d) => ({ ...d, label: d.name })));
      } catch {
        showNotification(
          t("notifications.general.fetchError", {
            obj: t("reflectionTemplates.reflectionTemplates"),
          }),
          ERROR
        );
      }
    }
    fetchData();
  }, [showNotification]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    if (queryParams.get("mode") === "create") {
      setMode("create");
    } else if (queryParams.get("mode") === "edit") {
      setMode("edit");
      setSelectedTemplate(queryParams.get("id"));
    } else {
      setMode("view");
    }
  }, [location]);

  return (
    <>
      {mode === "view" && (
        <ViewReflectionTemplates
          templates={templates}
          setTemplates={setTemplates}
          cycleTypes={cycleTypes}
        />
      )}
      {mode === "create" && (
        <ManageReflectionTemplate
          mode={mode}
          templates={templates}
          setTemplates={setTemplates}
          cycleTypes={cycleTypes}
          allDepartments={allDepartments}
        />
      )}
      {mode === "edit" && (
        <ManageReflectionTemplate
          mode={mode}
          templates={templates}
          template={templates?.find((t) => t.id === selectedTemplate)}
          setTemplates={setTemplates}
          cycleTypes={cycleTypes}
          allDepartments={allDepartments}
        />
      )}
    </>
  );
};

export default ReflectionTemplates;
